import React, { useState } from 'react';
import './InputSearch.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

export default function InputSearch() {
    const [searchTerm, setSearchTerm] = useState("");
    const [modalOpen, setModalOpen] = useState(false);

    // Lista de enlaces normalizada con los nuevos nombres
    const enlaces = [
        { title: 'Banners', link: '/dashboard/banners' },
        { title: 'Usuarios', link: '/dashboard/usuarios' },
        { title: 'Información de contacto', link: '/dashboard/contacto' },
        { title: 'Categorías', link: '/dashboard/categorias' },
        { title: 'Servicios', link: '/dashboard/servicios' },
    ];

    const handleSearch = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
        setModalOpen(value !== "");
    };

    const closeModal = () => {
        setModalOpen(false);
        setSearchTerm(""); // Opcional: limpia el buscador al hacer click
    };

    const filteredEnlaces = enlaces.filter((enlace) =>
        enlace.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="inputSearchDashboard">
            <div className='search'>
                <FontAwesomeIcon icon={faSearch} className="search-icon" />
                <input
                    type="text"
                    placeholder="Buscar..."
                    value={searchTerm}
                    onChange={handleSearch}
                    className="input"
                />
            </div>

            {modalOpen && (
                <div className="modalInput">
                    {filteredEnlaces.length > 0 ? (
                        filteredEnlaces.map((enlace, index) => (
                            <div key={index}>
                                <Link to={enlace.link} onClick={closeModal} className='link'>
                                    <FontAwesomeIcon icon={faSignOutAlt} />
                                    {enlace.title}
                                </Link>
                            </div>
                        ))
                    ) : (
                        <p className="no-results">No hay resultados.</p>
                    )}
                </div>
            )}
        </div>
    );
}